import _get from 'lodash/get';

import { findAllValues } from 'utils/DICTIONARY';

export default function formatEntityType(status) {
  const statusMap = findAllValues('entityTypeChoices') || {};
  return _get(statusMap, status, '');
}
